// Returns array of paths of all custom fields with certain type
export function getPathsByType (customFields, fieldType) {
  const res = []
  for (const cf of customFields) {
    for (const field of cf.fields) {
      if (field.type === fieldType) {
        res.push(field.paths[0])
      }
    }
  }
  return res
}



// WEBPACK FOOTER //
// ./src/utils/customFieldsUtils.js